



































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import api from '@/api'
import { TextInput, Button } from '@alpha/ink'

@Component({
  components: {
    TextInput,
    Button
  }
})
export default class ForgotPassword extends Vue {
  @Prop({ default: '' }) initialMessage!: string

  email: string = ''
  processing: boolean = false
  message: string = ''
  messageType: 'error' | 'success' | false = false

  mounted () {
    if (this.initialMessage) this.message = this.initialMessage
  }

  @Watch('initialMessage')
  valueUpdated (message: string) {
    this.message = message
  }

  toggleMode () {
    this.$emit('toggleMode')
  }

  validateEmail (email: string): boolean {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
  }

  handleFormKeypress (e: KeyboardEvent) {
    e.stopPropagation()
    if (e.key === 'Enter') {
      e.preventDefault()
      this.submit()
    }
  }

  async submit () {
    this.message = ''
    if (!this.email || !this.email.trim() || !this.validateEmail(this.email)) {
      this.message = 'Please enter a valid email address.'
      this.messageType = 'error'
      return
    }
    this.processing = true
    const resp = await api.forgotPasswordEmail(this.email)
    if (resp.status) {
      this.message = "We've sent you an email with instructions"
      this.messageType = 'success'
      setTimeout(() => {
        this.toggleMode()
      }, 5000)
    } else {
      this.message = resp.error || 'Error sending reset password email.'
      this.messageType = 'error'
    }

    this.processing = false
  }
}
